import type { PreferenciasConfig, WidgetConfig } from './types';

/** Rendimiento en canal por defecto (% del peso en pie) cuando no hay dato específico. */
export const DEFAULT_RENDIMIENTO_CANAL = 52;

export const widget = (
  id: string,
  tipo: WidgetConfig['tipo'],
  params: WidgetConfig['params'] = {},
  visible = true,
): WidgetConfig => ({ id, tipo, visible, params });

/** Configuración neutra (sin perfil elegido). `shared/domain/perfiles.ts` arma las de cada perfil. */
export function createDefaultPrefs(): PreferenciasConfig {
  return {
    schema: 1,
    perfilAplicado: null,
    moneda: 'USD',
    bsModo: 'actual',
    rendimientoCanalPct: DEFAULT_RENDIMIENTO_CANAL,
    rendimientoPorCategoria: {},
    home: {
      widgets: [
        widget('w-bcv', 'bcv'),
        widget('w-resumen', 'resumen'),
        widget('w-noticias', 'noticias'),
        widget('w-movers', 'movers', { periodoDias: 7 }),
        widget('w-favoritos', 'favoritos'),
        widget('w-calculadora', 'calculadora'),
        widget('w-fuentes', 'fuentes'),
      ],
    },
    intereses: { rubros: [], regiones: [], fuentes: [] },
    favoritos: [],
    vista: 'tarjetas',
    csvSeparador: ';',
  };
}
